export default __webpack_public_path__ + "static/media/more_report_top.8337da30.png";